var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareSkype({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.52,
    y1: 22.51,
    x2: 67.48,
    y2: 67.48,
    gradientTransform: "translate(78.46 -9.14) rotate(76.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007dd6"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(-9.13 78.46) rotate(-76.72)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.51,49.39c0,.1,0,.19-.05.28l-.09-.53.14.25a25.23,25.23,0,0,0,.42-4.51A24.9,24.9,0,0,0,45,20a25.56,25.56,0,0,0-4.71.44h0l.26.14L40,20.47l.27-.06a14.87,14.87,0,0,0-6.92-1.72A14.73,14.73,0,0,0,20.48,40.58a2.51,2.51,0,0,1,0-.27l.09.53c0-.09-.09-.17-.13-.26A24.9,24.9,0,0,0,45,69.79a24.49,24.49,0,0,0,4.37-.39l-.26-.14.54.1-.28,0a14.74,14.74,0,0,0,20.13-20ZM45.11,60.13c-8.85,0-12.81-4.35-12.81-7.61a2.78,2.78,0,0,1,2.94-2.84c3.79,0,2.81,5.44,9.87,5.44,3.62,0,5.62-2,5.62-4,0-1.21-.6-2.55-3-3.14l-7.87-2c-6.34-1.59-7.49-5-7.49-8.24,0-6.69,6.3-9.2,12.21-9.2,5.45,0,11.87,3,11.87,7,0,1.71-1.49,2.71-3.19,2.71-3.23,0-2.64-4.47-9.15-4.47-3.23,0-5,1.46-5,3.56s2.55,2.75,4.77,3.26L49.71,42c6.38,1.42,8,5.15,8,8.66,0,5.44-4.18,9.49-12.6,9.49Zm4,9.13.54.1-.28,0-.26-.14ZM69.46,49.67l-.09-.53.14.25c0,.1,0,.19-.05.28ZM20.52,40.31l.09.53c0-.09-.09-.17-.13-.26a2.51,2.51,0,0,1,0-.27Zm20-19.76L40,20.47l.27-.06Z",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSkype);
export default __webpack_public_path__ + "static/media/share-skype.6eb7801a60473cc8f1afc25649f64371.svg";
export { ForwardRef as ReactComponent };